import React from "react";
import { Link } from "react-router-dom";

/**
 * Wrapper for public legal pages (terms, privacy).
 */
function LegalDocumentLayout({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="sticky top-0 z-10 border-b border-gray-200 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-4 sm:px-6">
          <Link
            to="/"
            className="text-sm font-medium text-primary-600 transition-colors hover:text-primary-800"
          >
            ← Back to Kuzko History
          </Link>
        </div>
      </header>
      <article className="mx-auto max-w-3xl px-4 py-10 sm:px-6 sm:py-12">
        <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          {title}
        </h1>
        {lastUpdated && (
          <p className="mt-2 text-sm text-gray-500">{lastUpdated}</p>
        )}
        <div className="mt-10 space-y-8 text-base leading-relaxed text-gray-800">
          {children}
        </div>
      </article>
    </div>
  );
}

export default LegalDocumentLayout;
